function getVariable(varName, options) {
  return options.data.root[varName];
}

export default getVariable;
